import { createApi } from '@/api/modules/utils'

const baseUrl = '/account'
const api = createApi(baseUrl)

// 账号相关
export const accountApi = {
  info: api('info', 'get'),
  updatePassword: api('update_password', 'post'),
}